import module from 'module';

import templateUrl from './customer-page.template.html';

module.component('customerPage', {
  templateUrl,
  transclude: true,
});